module.exports = __webpack_public_path__ + "Roboto-Thin.954bbdeb86483e4ffea0.woff2";


//////////////////
// WEBPACK FOOTER
// /var/www/html/prod/resources/assets/frontend/src/assets/font/roboto/Roboto-Thin.woff2
// module id = ../../../../../src/assets/font/roboto/Roboto-Thin.woff2
// module chunks = 29